import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { CardFooter } from "@/components/ui/card";

type MessagingSettingsCardFooterProps = {
  onCancel: () => void;
  onSave: () => void;
  isSaving?: boolean;
};

export function MessagingSettingsCardFooter({
  onCancel,
  onSave,
  isSaving = false,
}: MessagingSettingsCardFooterProps) {
  const { t } = useTranslation();

  return (
    <CardFooter className="border-border flex justify-end gap-3 border-t px-6 py-4">
      <Button type="button" variant="new_outline" size="lg" onClick={onCancel}>
        {t("layout.messagingSettingsPage.cancel")}
      </Button>
      <Button
        type="button"
        variant="new_default"
        size="lg"
        onClick={onSave}
        disabled={isSaving}
      >
        {t("layout.messagingSettingsPage.save")}
      </Button>
    </CardFooter>
  );
}
